import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconFileSettings } from "@tabler/icons-react";
import { ReportesConfiguracionDef } from "./ReportesConfiguracionDef";

export const ReportesConfiguracionIcon = IconFileSettings;
export const ReportesConfiguracionHelpText = '* Configuración de Reportes.';

export class ReportesConfiguracion extends Entity<ReportesConfiguracionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ReportesConfiguracionDef(), parentKeys);
        this.Form = import('./ReportesConfiguracionForm').then((module) => module.ReportesConfiguracionForm);
        this.Title = "Configuración de Reportes";
        this.HelpText = ReportesConfiguracionHelpText;
        this.Icon = ReportesConfiguracionIcon;
    }
}